const OfferContractPage = () => {
  return (
    <section className="mb-8">
      <h3 className="text-[40px] font-semibold mb-8 ">Договір оферти</h3>
      <h4 className="text-2xl font-semibold mb-8">
        Згідно чинного законодавства України
      </h4>
      <p>
        ДОГОВІР ПУБЛІЧНОЇ ОФЕРТИ про надання послуг Компанія «LOX», далі за
        текстом - «LOX», в особі керуючого бюро Командна Дипломна Робота, що діє
        на підставі Статуту, що іменується надалі «Виконавець», з однієї
        сторони, та особа, яка приєдналась до цього Договору, шляхом прийняття
        пропозиції укласти цей Договір на умовах, визначених Виконавцем, що
        іменується надалі «Замовник», з іншої сторони, надалі разом - «Сторони»,
        а кожен окремо - «Сторона», виражаючи свою вільну волю та керуючись
        нормами чинного законодавства України, уклали цей Договір про надання
        послуг (надалі - «Договір») про наступне: 1. ЗАГАЛЬНІ ПОЛОЖЕННЯ 1.1.
        Договір є публічним договором в розумінні статті 633 Цивільного кодексу
        України, а особа, яка приймає пропозицію (публічну оферту) про укладення
        Договору (здійснює акцепт) стає Замовником відповідно до статті 642
        Цивільного кодексу України, статті 11 Закону України «Про електронну
        комерцію» та умов цього Договору.
        <br /> 1.2. Договір є пропозицією (публічною офертою) необмеженому колу
        фізичних і юридичних осіб укласти з Виконавцем Договір шляхом повного і
        безумовного прийняття умов цього Договору.
        <br /> 1.3. Умови Договору є однаковими для усіх осіб, які вирішили
        прийняти умови цього Договору.
        <br /> 1.4. Договір є договором приєднання в розумінні статті 634
        Цивільного кодексу України, оскільки його умови визначені Виконавцем і
        можуть бути прийняті Замовником лише шляхом приєднання до
        запропонованого Договору в цілому. У разі незгоди Замовника з усіма чи
        окремими положеннями цього Договору укладення Договору не відбувається.
        <br /> 1.5. Приєднанням до Договору вважається оплата послуг Виконавця
        шляхом безготівкового переказу коштів на підставі рахунку, виставленого
        Виконавцем, в тому числі, з використанням електронного платіжного
        засобу.
        <br /> 1.6. Договір вважається укладеним з дати надходження Виконавцю
        оплати за послуги, здійсненої Замовником на умовах, встановлених цим
        Договором.
        <br /> 1.7. Сторони можуть погодити інший спосіб приєднання до Договору
        та визначити інший момент укладення Договору.
        <br /> 1.8. Вчинення Замовником дій, передбачених пунктом 1.5 цього
        Договору, вважається прийняттям Замовником пропозиції про укладення
        Договору (здійснення акцепту), а також підтверджує факт повного і
        безумовного прийняття Замовником умов цього Договору без будь-яких
        застережень чи зауважень відповідно до статті 642 Цивільного кодексу
        України. Приймаючи пропозицію Виконавця
        <br /> (публічну оферту), Замовник погоджуєтесь з усіма умовами цього
        Договору і підтверджує, що йому зрозумілий зміст Договору і правові
        наслідки його укладення.
        <br /> 1.9. Договір є електронним договором в розумінні статті 3 Закону
        України «Про електронну комерцію», укладається з використанням доступних
        інформаційно-телекомунікаційних систем та не може бути визнаний
        недійсним у зв`язку з його вчиненням в електронній формі.
        <br /> 1.10. Цей Договір у паперовій формі може бути наданий за
        зверненням Замовника, а також може бути роздрукований Замовником
        самостійно з веб-сайту Виконавця: https://marmaer.ua/.
        <br /> 1.11. Терміни, що використовуються у цьому Договорі, вживаються у
        таких значеннях:
        <br /> 1.11.1. Публічна оферта — пропозиція Виконавця про укладення
        Договору, розміщена на веб-сайті Виконавця та викладена Виконавцем в
        умовах цього Договору, що адресована невизначеному колу фізичних і
        юридичних осіб;
        <br /> 1.11.2. Акцепт — повне, безумовне та беззастережне прийняття
        Замовником умов Договору шляхом оплати послуг Виконавця або іншим
        способом, погодженим Сторонами;
        <br />
        1.11.3. Замовник — фізична або юридична особа, яка отримує від Виконавця
        послуги на умовах, передбачених Договором;
        <br /> 1.11.4. Веб-сайт Виконавця — сукупність веб-сторінок, доступних у
        мережі Інтернет під доменним ім`ям marmaer.ua;
        <br /> 1.11.5. Постачальники послуг проміжного характеру в інформаційній
        сфері - оператори (провайдери) телекомунікацій, оператори послуг
        платіжної інфраструктури, реєстратори (адміністратори), що присвоюють
        мережеві ідентифікатори, та інші суб`єкти, що забезпечують передачу та
        зберігання інформації з використанням інформаційно-телекомунікаційних
        систем, що створюється, використовується, поширюється відповідно до умов
        Договору.
        <br /> 1.12. Договір укладається на підставі пропозиції його укласти
        (публічної оферти) з боку Виконавця та її прийняття (акцепту)
        Замовником.
        <br /> 1.13. Публічна оферта Виконавця викладена в умовах цього
        Договору.
        <br /> 1.14. Акцептом Публічної оферти є здійснення Замовником дій,
        визначених пунктом 1.5 Договору, що мають наслідком укладення цього
        Договору.
        <br />
        1.15. Укладаючи Договір, Замовник підтверджує:
        <br /> 1.15.1. повне та вичерпне ознайомлення з Публічною офертою,
        викладеної в умовах цього Договору;
        <br /> 1.15.2. безумовне та беззастережне прийняття ним Публічної
        оферти, викладеної в умовах цього Договору;
        <br /> 1.15.3. цілковите розуміння змісту своїх зобов`язань за Договором
        і правових наслідків його укладення.
        <br /> 1.16. Підтвердженням укладення Договору є квитанція, чек,
        платіжне доручення, інший розрахунковий або касовий документ (в
        електронній та/або паперовій формі), що засвідчує факт оплати послуг,
        які є предметом Договору, відповідно до вимог законодавства України,
        якщо інше не погоджено Сторонами. 2. ПРЕДМЕТ ДОГОВОРУ 2.1. На умовах та
        в порядку, передбачених цим Договором, Виконавець зобов`язується
        надавати, а Замовник приймати та оплачувати послуги
        інформаційно-консультаційного характеру з питань українського та
        міжнародного законодавства, бізнес-діяльності та менеджменту,
        бухгалтерського обліку та фінансової звітності, оподаткування тощо
        (надалі - послуги).
        <br /> 2.2. Предметом Договору є послуги, які Замовник обрав з переліку
        послуг, розміщених на веб-сайті Виконавця.
        <br /> 2.3. Послуги за Договором, на розсуд Виконавця, можуть включати:
        семінари, вебінари, круглі столи, доповіді, форуми, тематичні
        обговорення, лекції, усні, письмові, групові, індивідуальні
        консультації, відповіді на запитання, аналітичні, методичні та
        консультаційні матеріали, огляди законодавчих змін і судової практики
        тощо.
        <br /> 2.4. Тематика, спосіб надання та строк (термін) надання послуг
        зазначаються на веб-сайті Виконавця.
        <br /> 2.5. Виконавець самостійно формує перелік послуг, що можуть бути
        надані Замовнику на підставі цього Договору, та розміщує такий перелік
        послуг на веб-сайті Виконавця.
        <br /> 2.6. Місце надання послуг вказується на веб-сайті Виконавця. 3.
        ПОРЯДОК НАДАННЯ ПОСЛУГ 3.1. Для отримання послуг за Договором Замовник
        повинен пройти реєстрацію у Виконавця. Реєстрація здійснюється за
        номером телефону або через адресу електронної пошти, вказану на веб-
        сайті Виконавця, а також через веб-сайт Виконавця шляхом замовлення
        рахунку на оплату послуг Виконавця або оплати послуг Виконавця з
        використанням електронного платіжного засобу.
        <br /> 3.2. При реєстрації Замовник зобов`язаний надати Виконавцю
        відомості про: 3.2.1. ім`я, прізвище та по батькові (за наявності)
        та/або найменування; 3.2.2. посаду (за наявності);
        <br /> 3.2.3. реєстраційний номер облікової картки платника податків
        та/або код за Єдиним державним реєстром підприємств та організацій
        України;
        <br /> 3.2.4. засоби зв`язку (номер телефону, адресу електронної пошти
        тощо);
        <br /> 3.2.5. кількість учасників заходу, що охоплюється обраною
        послугою.
        <br /> 3.3. Якщо Виконавцю необхідна додаткова інформація, він має право
        запросити її у Замовника. У разі ненадання необхідної інформації
        Замовником, Виконавець не несе відповідальності за можливі недоліки
        первинних документів та інших документів, що складаються в процесі
        виконання умов Договору.
        <br /> 3.4. З моменту здійснення реєстрації розпочинається процес
        укладення Договору та Сторони беруть на себе зобов`язання забезпечити
        виконання умов, передбачених Договором для його укладення.
        <br /> 3.5. Замовник несе відповідальність за достовірність наданої при
        реєстрації інформації.
        <br />
        3.6. Замовник здійснює реєстрацію тільки після ознайомлення з умовами
        цього Договору, викладеними на веб-сайті Виконавця.
        <br /> 3.7. Після реєстрації на адресу електронної пошти Замовника
        надсилається рахунок для оплати обраних ним послуг, якщо інше не
        передбачено способом розрахунків, обраним Замовником.
        <br /> 3.8. Оплата послуг згідно з виставленим рахунком є згодою
        отримати послуги, обрані Замовником на веб-сайті Виконавця.
        <br /> 3.9. Виконавець надає послуги відповідно до законодавства України
        та умов цього Договору.
        <br /> 3.10. Послуги надаються шляхом проведення офлайн заходів (з
        фізичним перебуванням осіб у визначеному місці) та онлайн заходів (через
        мережу Інтернет за допомогою сервісів віддаленого перегляду), а також в
        інших формах та іншими способами, визначеними Виконавцем.
        <br /> 3.11. У разі надання послуг у формі онлайн заходу, Виконавець
        зобов`язаний надати Замовнику доступ для перегляду онлайн заходу на
        Інтернет-платформі, обраній Виконавцем, не пізніше ніж за 2 (два)
        календарні дні до дати проведення онлайн заходу.
        <br />
        3.12. Дата проведення заходу (початку проведення заходу) зазначається на
        веб-сайті Виконавця.
        <br /> 3.13. Виконавець не несе відповідальності, якщо Замовник
        пропустив захід, який розпочався у час, вказаний на веб-сайті Виконавця,
        або протягом 15 хвилин, після настання часу, вказаного на веб- сайті
        Виконавця.
        <br /> 3.14. Послуги вважаються наданими Замовнику з моменту закінчення
        заходу, що відповідає опису, наведеному на веб-сайті Виконавця.
        <br /> 3.15. Після надання послуг, обраних Замовником, Виконавець
        оформляє Акт про надані послуги (надалі - «Акт») у 2 (двох) примірниках.
        Акт надається (надсилається) Замовнику протягом 5 (п`яти) календарних
        днів з дати його підписання Виконавцем.
        <br /> 3.16. Замовник зобов`язаний протягом 5 (п`яти) календарних днів
        після дати отримання Акту розглянути його, підписати та повернути один
        примірник підписаного Акту Виконавцю або надати свої письмові
        обґрунтовані зауваження щодо якості чи інших умов надання послуг.
        <br /> 3.17. У разі відмови Замовника у підписанні отриманого від
        Виконавця Акту Сторони проводять переговори щодо якості чи інших умов
        надання послуг протягом 10 (десяти) календарних днів після повідомлення
        Замовником про відмову у підписанні Акту та підписують Акт з урахуванням
        змін, внесених за результатами переговорів.
        <br /> 3.18. У разі якщо протягом строку ведення переговорів,
        встановленого пунктом 3.17 цього Договору, Сторони не дійшли згоди щодо
        врегулювання розбіжностей щодо якості чи інших умов надання послуг, спір
        між Сторонами може бути переданий для розгляду у судовому порядку
        відповідно до вимог чинного законодавства України або в іншому порядку,
        погодженому Сторонами.
        <br />
        3.19. У разі, якщо Виконавець не отримав від Замовника підписаного з
        боку Замовника примірника Акту або письмових обґрунтованих зауважень
        щодо якості чи інших умов надання послуг протягом 30 (тридцяти)
        календарних днів з дати надання (надіслання) Замовнику Акту, відповідний
        Акт вважається підписаним і погодженим Замовником, а послуги Виконавця -
        надані належним чином та прийняті Замовником в повному обсязі без
        зауважень. 4. ПРАВА ТА ОБОВ`ЯЗКИ СТОРІН 4.1. Виконавець має право:
        <br />
        4.1.1. отримувати від Замовника інформацію, необхідну для надання
        послуг;
        <br /> 4.1.2. самостійно встановлювати ціну послуг та інші умови їх
        надання шляхом розміщення відповідної інформації на веб-сайті Виконавця;
        <br /> 4.1.3. вносити зміни до Договору шляхом їх розміщення на
        веб-сайті Виконавця без спеціального повідомлення Замовника;
        <br /> 4.1.4. зберігати та обробляти персональні дані, отримані в
        процесі надання послуг, відповідно до вимог чинного законодавства
        України;
        <br /> 4.1.5. призупинити надання послуг при несвоєчасному виконанні
        Замовником своїх грошових зобов`язань з оплати послуг;
        <br /> 4.1.6. повністю або частково призупинити надання послуг у разі
        неможливості надання послуг у зв`язку з технічними або іншими
        об`єктивними причинами.
        <br /> 4.2. Виконавець зобов`язаний:
        <br /> 4.2.1. надавати послуги відповідно до умов цього Договору;
        <br /> 4.2.2. надавати роз`яснення з питань, що виникають у Замовника в
        зв`язку з наданням йому послуг; 4.2.3. забезпечити можливість перегляду
        Замовником онлайн заходів у порядку, передбаченому Договором;
        <br /> 4.2.4. надавати послуги особисто та/або з залученням третіх осіб,
        залишаючись при цьому відповідальним в повному обсязі перед Замовником
        за надання послуг;
        <br /> 4.2.5. забезпечити захист персональних даних, отриманих від
        Замовника.
        <br /> 4.3. Замовник має право:
        <br /> 4.3.1. отримувати послуги, надані Виконавцем відповідно до умов
        Договору;
        <br />
        4.3.2. отримувати повну та достовірну інформацію про обсяг наданих
        послуг, а також роз`яснення з питань, що виникають у Замовника в зв`язку
        з наданням йому послуг.
        <br /> 4.4. Замовник зобов`язаний:
        <br /> 4.4.1. самостійно ознайомитись з умовами Договору, розміщеного на
        веб-сайті Виконавця;
        <br />
        4.4.2. надавати достовірну і повну інформацію, необхідну для укладення
        та виконання Договору;
        <br /> 4.4.3. здійснювати оплату за надані послуги відповідно до умов
        Договору за цінами, визначеними Виконавцем;
        <br /> 4.4.4. негайно повідомляти Виконавця про зміну своїх реквізитів,
        обставини та факти, які є важливими для надання послуг за Договором;
        <br /> 4.4.5. не копіювати та не розповсюджувати без письмової згоди
        Виконавця отримані в процесі виконання Договору консультації, матеріали,
        презентації, роз`яснення, іншу інформацію;
        <br /> 4.4.6. забезпечити Виконавця приміщенням та технічними засобами
        (у разі надання послуг за місцезнаходженням Замовника). 5. ЦІНА ПОСЛУГ
        ТА ПОРЯДОК РОЗРАХУНКІВ 5.1. Ціна послуг Виконавця вказується на
        веб-сайті Виконавця.
        <br /> 5.2. Виконавець має право в односторонньому порядку змінити ціну
        на будь-яку послугу, зазначивши нову ціну послуги на веб-сайті
        Виконавця.
        <br /> 5.3. Вартість послуг, обраних Замовником, визначається на
        підставі рахунків, що становлять невід`ємну частину цього Договору.
        <br /> 5.4. Зміна Виконавцем ціни послуги, оплаченої Замовником, не
        допускається.
        <br /> 5.5. Виконавець надає Замовнику послуги за умови їх попередньої
        оплати. Замовник здійснює попередню оплату обраних послуг не пізніше як
        за 5 (п`ять) календарних днів до дати надання послуг. Сторони можуть
        погодити інший строк оплати послуг Виконавця.
        <br />
        5.6. Розрахунки між Замовником і Виконавцем здійснюються способами,
        зазначеними на веб-сайті Виконавця.
        <br /> 5.7. У разі оформлення Замовником платіжних документів в графі
        «Призначення платежу» обов`язково зазначається посилання на номер і дату
        рахунку, виставленого Виконавцем.
        <br /> 5.8. Платіж вважається виконаним з моменту зарахування коштів на
        поточний рахунок Виконавця. Відповідальність за правильність здійснення
        переказу коштів покладається на Замовника.
        <br /> 5.9. У разі неможливості або відмови скористатися послугами
        Виконавця, Замовник не пізніше ніж за 3 (три) календарні дні до дати
        надання послуги, зазначеної в рахунку, письмово повідомляє Виконавця про
        це. Виконавець на підставі письмової заяви здійснює повернення сплачених
        Замовником коштів протягом 5 (п`яти) робочих днів з дня надання
        Замовником письмової заяви із зазначенням реквізитів рахунку Замовника.
        <br /> 5.10. У разі неможливості чи відмови скористатися послугами
        Виконавця менше ніж за 3 (три) календарні дні до дати надання послуг,
        оплата, внесена Замовником за послуги, не повертається, якщо інше не
        погоджено Сторонами.
        <br /> 5.11. Оплата Замовником послуг означає повну та безумовну згоду
        Замовника з Публічною офертою, викладеною в умовах цього Договору.
        <br /> 5.12. У ціну послуг включені податки і збори (інші обов`язкові
        платежі), які підлягають сплаті Виконавцем у зв`язку з виконанням умов
        Договору відповідно до вимог чинного законодавства України. 6.
        ВІДПОВІДАЛЬНІСТЬ СТОРІН 6.1. За порушення Договору Сторони несуть
        відповідальність у відповідності до положень чинного законодавства
        України та умов цього Договору.
        <br /> 6.2. Порушенням Договору є його невиконання або неналежне
        виконання, тобто виконання з порушенням умов, визначених змістом цього
        Договору.
        <br /> 6.3. Виконавець не несе відповідальності за неналежне виконання
        або невиконання умов цього Договору у випадку, якщо Замовник не
        забезпечив надання інформації та документів, необхідних для надання
        послуг, або у разі надання інформації та документів у неповному обсязі
        чи надання суперечливої і/або недостовірної інформації та/або
        документів.
        <br /> 6.4. Замовник несе відповідальність за достовірність і повноту
        відомостей, вказаних при реєстрації. У випадку якщо Замовник не вказав
        або невірно вказав відомості про себе, Виконавець не відповідає за
        збитки Замовника, понесені в результаті відмови в поверненні
        передоплати, наданні послуг, та/або здійснення інших дій внаслідок
        неможливості правильної ідентифікації Замовника.
        <br /> 6.5. У випадку ненадання послуг з вини Виконавця, Виконавець
        повертає Замовнику здійснену оплату протягом 5 (п`яти) календарних днів
        на підставі письмової заяви Замовника.
        <br /> 6.6. У разі прострочення Замовником оплати послуг станом на день
        їх надання, Замовник позбавляється права на отримання послуг, якщо інше
        не погоджено Сторонами.
        <br /> 6.7. У випадку прострочення Замовником оплати послуг Замовник
        зобов`язується сплатити на користь Виконавця пеню у розмірі подвійної
        облікової ставки Національного банку України від суми невиконаного
        грошового зобов`язання за кожен день прострочення платежу.
        <br />
        6.8. У випадку прострочення Замовником оплати послуг понад 30 (тридцять)
        календарних днів з дати надання послуг, Замовник сплачує на користь
        Виконавця, окрім пені, передбаченої пунктом 6.7 Договору, також штраф у
        розмірі вартості неоплачених послуг.
        <br /> 6.9. У випадку здійснення Замовником оплати, але неотримання
        послуг з незалежних від волі Виконавця причин, такі кошти можуть бути
        зараховані за згодою Замовника в рахунок майбутніх платежів за послуги,
        що будуть надані Виконавцем, або підлягають поверненню на вимогу
        Замовника.
        <br /> 6.10. Якщо для оплати послуг на веб-сайті Виконавця
        використовуються платіжні системи, то відповідальність за правильність
        та своєчасність переказу коштів, а також збереження та обробку
        персональних даних й іншої інформації, наданої для ініціювання переказу
        коштів, несе оператор послуг платіжної інфраструктури в порядку,
        передбаченому законодавством України.
        <br /> 6.11. Виконавець не несе відповідальність за порушення умов
        Договору, допущене ним з вини постачальника послуг проміжного характеру
        в інформаційній сфері. 7. ОБСТАВИНИ НЕПЕРЕБОРНОЇ СИЛИ (ФОРС-МАЖОР) 7.1.
        Сторони звільняються від відповідальності за невиконання або неналежне
        виконання зобов`язань за Договором, якщо це сталося внаслідок дії
        обставин непереборної сили, тобто надзвичайних та непередбачуваних
        обставин, які виникли після укладення цього Договору, не залежать від
        волі Сторін і перебувають поза їх контролем, до яких відносяться,
        зокрема, але не виключно, бойові дії, революції, державні перевороти,
        стихійні лиха, техногенні та інших аварій, аварії в системі
        електропостачання та зв`язку, страйки, локаути, диверсійні та
        терористичні акти, рішення державних та місцевих органів влади,
        епідемії, пандемії, надзвичайні ситуації, що роблять об`єктивно
        неможливим виконання умов Договору (далі — «форс-мажор»).
        <br /> 7.2. Форс-мажор застосовується, а Сторона, для якої настав
        форс-мажор, звільняється від відповідальності за порушення умов
        Договору, якщо отримано сертифікат Торгово-промислової палати України чи
        регіональної торгово-промислової палати або інший офіційний документ,
        виданий уповноваженим органом чи організацією держави, де трапився
        форс-мажор.
        <br /> 7.3. Сторона, для якої настав форс-мажор, зобов`язана повідомити
        про це іншу Сторону протягом 3 (трьох) календарних днів з дати, коли
        Стороні стало відомо про настання форс-мажору, та надати іншій Стороні
        належні документи для підтвердження форс-мажору.
        <br /> 7.4. З моменту отримання повідомлення про форс-мажор іншою
        Стороною виконання умов Договору призупиняється, а строк виконання
        зобов`язань за Договором подовжується на період існування форс-мажору.
        <br /> 7.5. Призупинення виконання умов Договору означає, що Виконавець
        припиняє надання послуг, передбачених Договором, а Замовник не повинен
        здійснювати подальші платежі за послуги, які не були надані, без
        негативних наслідків, штрафних санкцій та відповідальності для кожної з
        Сторін.
        <br /> 7.6. Сторона, для якої настав форс-мажор, зобов`язана повідомити
        іншу Сторону про припинення дії форс-мажору протягом 3 (трьох)
        календарних днів з дати, коли Стороні стало відомо про припинення дії
        форс-мажору.
        <br /> 7.7. Кожна Сторона має право ініціювати припинення Договору, якщо
        тривалість форс-мажору перевищує 1 (один) місяць. 8. ПРАВА
        ІНТЕЛЕКТУАЛЬНОЇ ВЛАСНОСТІ 8.1. Виконавцю належать виключні права на
        об`єкти інтелектуальної власності, створені під час виконання Договору,
        включаючи права, передбачені законодавством України, Бернською
        конвенцією про охорону літературних та художніх творів 1886 року і
        Всесвітньою конвенція про авторське право 1952 року, іншими
        міжнародно-правовими актами, а саме:
        <br /> 8.1.1. виключне право на використання об`єкта інтелектуальної
        власності;
        <br /> 8.1.2. виключне право дозволяти використання об`єкта
        інтелектуальної власності;
        <br /> 8.1.3. виключне право запобігати незаконному використанню об`єкта
        інтелектуальної власності, включаючи право забороняти таке використання;
        <br /> 8.1.4. інші права інтелектуальної власності, які існують сьогодні
        або з`являться в майбутньому.
        <br /> 8.2. Об`єктами інтелектуальної власності для цілей цього Договору
        є, зокрема, але не виключно, веб-сайт Виконавця, інформація, розміщена
        на веб-сайті Виконавця, в тому числі, тексти, інфографіки, презентації,
        зображення, аудіовізуальні твори тощо, робочі і рекламні матеріали,
        комерційні повідомлення, маркетингові дослідження у паперовій,
        електронній чи будь-якій іншій формі, програмне забезпечення, логотипи,
        графіки, звуки тощо, що використовуються або створені Виконавцем в
        процесі виконання умов Договору.
        <br /> 8.3. Виключні права Виконавця на об`єкти інтелектуальної
        власності, створені в процесі виконання Договору, поширюються на готовий
        об`єкт інтелектуальної власності (в електронній, паперовій та інших
        формах), а також на матеріали, отримані в процесі його створення, на
        аудіо- та відеозапис, незалежно від мови та форм вираження, включаючи
        компіляції даних та програмне забезпечення.
        <br /> 8.4. Об`єкти інтелектуальної власності, що належать Виконавцю,
        можуть використовуватися Замовником на умовах обмеженої невиключної
        ліцензії, яка виключає можливість використання Замовником об`єктів
        інтелектуальної власності у сфері, тотожній або суміжній з діяльністю
        Виконавця, а також можливість видачі Замовником іншим особам ліцензій на
        використання об`єктів інтелектуальної власності Виконавця.
        <br /> 8.5. Надаючи право на використання об`єктів інтелектуальної
        власності Замовнику, Виконавець не передає Замовнику виключних прав
        інтелектуальної власності на такі об`єкти та не надає дозволу на їх
        використання в цілях здійснення діяльності, тотожної дозволу Виконавця,
        крім випадків, передбачених законодавством України.
        <br /> 8.6. Використання об`єктів інтелектуальної власності третіми
        особами допускається виключно з або суміжній з діяльністю Виконавця.
        <br /> 8.7. Виконавець використовує об`єкти права інтелектуальної
        власності, що належать іншим особам, на підставі ліцензій, договорів чи
        інших законних підставах.
        <br /> 8.8. Виконавець може вільно використовувати свої навички, ноу-хау
        та досвід, а також використовувати та розкривати будь-які узагальнені
        ідеї, концепції, методи, прийоми, отримані або засвоєні під час
        виконання Договору, без розголошення конфіденційної інформації
        Замовника. 9. ПЕРСОНАЛЬНІ ДАНІ 9.1. Кожна із Сторін дає згоду на збір та
        обробку своїх персональних даних (включаючи збирання, реєстрацію,
        накопичення, зберігання, адаптування, зміну, поновлення, використання і
        поширення (розповсюдження, реалізацію, передачу), знеособлення, знищення
        персональних даних, у тому числі з використанням інформаційних
        (автоматизованих) систем, а також інші види діяльності, які можуть
        виконувати Сторони щодо персональних даних в письмовій (паперовій),
        електронній та інших формах) зокрема, але не виключно, таких
        персональних даних: ім`я, прізвище, по батькові, дата народження, дані
        документу, що посвідчує особу (номер, серія, дата видачі, орган видачі
        тощо), реєстраційний номер облікової картки платника податків
        (податковий номер), витяг даних з державного реєстру юридичних осіб та
        фізичних осіб-підприємців, система оподаткування, інформація про освіту
        та кваліфікацію, номер телефону, адреса електронної пошти та інші дані,
        добровільно надані з метою забезпечення реалізації договірних відносин
        між Сторонами, ведення бухгалтерського та управлінського обліку,
        проведення рекламних кампаній та маркетингових досліджень, надсилання
        інформаційно-телекомунікаційними засобами зв`язку (електронною поштою,
        мобільним зв`язком, через месенджери, застосунки, соціальні мережі тощо)
        електронних комерційних повідомлень, комунікації та відносин з органами
        державної влади та органами місцевого самоврядування, а також для інших
        цілей, що охоплюють законний інтерес Виконавця.
        <br /> 9.2. Сторони беруть на себе зобов`язання забезпечити належний
        захист персональних даних від незаконної обробки та незаконного доступу
        третіх осіб, включаючи вжиття необхідних заходів для запобігання
        розголошенню персональних даних посадових осіб, працівників,
        уповноважених представників Сторін, якщо такі персональні дані були
        довірені Стороні або стали відомі Стороні у зв`язку з зобов`язаннями за
        Договором.
        <br /> 9.3. Укладенням Договору Замовник підтверджує, що він
        повідомлений (без додаткового повідомлення) про права суб`єкта
        персональних даних, встановлені Законом України «Про захист персональних
        даних», мету обробки персональних даних, склад і зміст зібраних
        персональних даних, а також умови доступу до персональних даних третіх
        осіб. 10. ВИРІШЕННЯ СПОРІВ 10.1. Спори, які виникають між Сторонами в
        процесі виконання цього Договору або у зв`язку з ним, вирішуються шляхом
        переговорів.
        <br /> 10.2. Усі спори Сторін, щодо яких не було досягнуто згоди, можуть
        бути передані для вирішення у судовому порядку відповідно до вимог
        чинного законодавства України.
        <br /> 10.3. За взаємною згодою Сторін спір може бути переданий для
        вирішення медіатору або іншому незалежному професійному посереднику. 11.
        СТРОК ДІЇ ДОГОВОРУ 11.1. Договір набирає чинності з дати, визначеної
        пунктом 1.6 цього Договору, і діє до повного виконання Сторонами своїх
        зобов`язань, передбачених Договором.
        <br /> 11.2. Дія Договору достроково припиняється:
        <br />
        11.2.1. за взаємною згодою Сторін;
        <br /> 11.2.2. за рішенням суду, що набрало законної сили;
        <br /> 11.2.3. з інших підстав, передбачених чинним законодавством
        України та цим Договором. 12. ІНШІ УМОВИ 12.1. Виконавець має право в
        односторонньому порядку вносити зміни до Договору шляхом оприлюднення
        змін до Договору на веб-сайті Виконавця. Зміни до Договору набирають
        чинності з дати їх оприлюднення на веб-сайті Виконавця, якщо інший
        термін набрання чинності не визначений додатково при їх оприлюдненні.
        <br /> 12.2. Виконавець за цим Договором має статус платника єдиного
        податку 3-ї групи.
        <br /> 12.3. З питань, що виникають у зв`язку з укладенням, виконанням і
        припиненням цього Договору та не врегульовані ним, Сторони
        зобов`язуються керуватися нормами чинного законодавства України, зокрема
        положеннями Цивільного кодексу України, Господарського кодексу України
        та Закону України «Про електронну комерцію».
        <br /> 12.4. Якщо будь-яке положення цього Договору стає недійсним, це
        не впливає на дійсність решти положень Договору. У такому випадку
        Сторони, наскільки це можливо, намагаються домовитися
        <br /> про заміну недійсної умови новими дійсними положеннями, що
        дозволяють максимально досягнути початкових намірів Сторін.
        <br /> 12.5. Сторони зобов`язуються зберігати у таємниці конфіденційну
        інформацію та комерційну таємницю, яка стала їм відомою у зв`язку з
        виконанням умов Договору, не розголошувати конфіденційну інформацію та
        комерційну таємницю іншої Сторони, а також не використовувати відповідну
        інформацію в своїх інтересах чи інтересах третіх осіб.
        <br /> 12.6. Сторони несуть повну відповідальність за повноту та
        достовірність наведених ними в документах реквізитів. Сторони
        зобов`язуються негайно повідомляти одна одну про зміну імені,
        найменування, організаційно-правової форми, місцезнаходження (місця
        проживання), адрес для листування, номерів телефонів, адрес електронної
        пошти, реквізитів банківських та інших рахунків. У випадку
        неповідомлення винна Сторона несе ризик настання пов`язаних з цим
        несприятливих наслідків (в тому числі, податкових). 13. АДРЕСА ТА
        РЕКВІЗИТИ ВИКОНАВЦЯ АБ СК «LOX»
        <br /> <br />
        Код ЄДРПОУ: 32528305
        <br /> Юридична адреса: 49005, м. Дніпро, пр-т. Д. Яворницького, буд. 99{' '}
        <br /> п/р UA623052990000026001050022341 в АТ КБ Приватбанк
        <br /> Тел.: (067) 135-85-85
        <br /> Е-mail: lox@gmail.com
        <br /> Керуючий бюро ________________________________ / Командна
        Дипломна Робота
      </p>
    </section>
  );
};

export default OfferContractPage;
